import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useDashboardCountsContext } from '@/dashboard/provider/DashboardCountsProvider';
import { DashboardBandSectionsType } from '@/dashboard/utils/DashboardCalculations/dashboardCalculations.utils';

function ContributionBar({ period }: { period: string }) {
  const { bandDetails } = useDashboardCountsContext();

  if (!(period in bandDetails)) {
    throw new Error(`Period, ${period} missing in context`);
  }

  const bands = bandDetails[period].bandSections;
  let gridTemplateColumns = 'repeat(4, 25%)';

  if (bands.length < 4) {
    if (bands.length === 1) {
      gridTemplateColumns = '1fr';
    } else {
      gridTemplateColumns = `1fr repeat(${bands.length - 1}, 25%)`;
    }
  }

  return (
    <Box
      height="100%"
      flex="1"
      minWidth={100}
      className="band-parent"
      display="grid"
      gridTemplateColumns={gridTemplateColumns}
      borderBottom="1px solid"
      borderLeft="1px solid"
      borderColor={(theme) => theme.palette.grey[800]}
      minHeight={36}
      sx={(theme) => ({
        borderRadius: 0.75,
        overflow: 'hidden',
        '> div:first-of-type': {
          flex: 1,
        },
        '> div': {
          borderTop: '1px solid',
          borderRight: '1px solid',
          borderColor: theme.palette.grey[800],
        },
      })}
    >
      {bands.map((bandContent) => {
        return <ColouredSvgRectangles key={`${bandContent.contents}`} {...bandContent} />;
      })}
    </Box>
  );
}

function ColouredSvgRectangles({
  colour,
  contents,
  type,
  tooltip,
  fontColour,
}: DashboardBandSectionsType[0]) {
  const shouldDisplayContent = type !== 'unsubmitted' && type != 'submitted';
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      title={tooltip}
      px={2}
      sx={{
        backgroundColor: colour,
      }}
    >
      {shouldDisplayContent ? (
        <Typography
          variant="caption"
          fontSize="0.875rem"
          fontWeight="500"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          overflow="hidden"
          color={fontColour}
        >
          {contents}
        </Typography>
      ) : null}
    </Box>
  );
}

function EmptyContributionBar() {
  return <Box height={36} flex="1" role="presentation" minWidth="25%"></Box>;
}

export { EmptyContributionBar };
export default ContributionBar;
